import React from 'react'
import Banner from '../components/Banner'
import PartnerImages from '../components/PartnerImages'
import AllCourses from '../components/AllCourses'
import Testimonials from '../components/Testimonials'

const Landing = () => {
  return (
    <div>
      <Banner />
      <PartnerImages />
      <AllCourses />
      <Testimonials />
    </div>
  )
}

export default Landing
